import Layout from "../../../components/layout";
import PageHeading from "../../../components/page-header";
import LogoSlider from "../../../components/logo-slider";

import fs from 'fs';
import path from 'path';

export async function getStaticProps() {
  const dir = path.join(process.cwd(), 'public/images/companies');
  const files = fs.readdirSync(dir);
  const logos = files.map((file) => `/images/companies/${file}`);

  return {
    props: { logos },
  };
}


export default function Sounds ({ logos }) {

    const settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        infinite:true,
        dots: false,
        pauseOnHover: false,
        variableWidth: true,
        centerMode: true,
        className:'container clients-slider',
        centerPadding: "60px",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode:true,
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              centerMode:true,
            }
          }
        ]
      };

  return (
      <Layout>
        <PageHeading heading_text='Sounds' image_url={'/images/heroslider/sound.webp'}/>

        <div className="section white-bg">
          <div className="container">
          <div className="row g-5 justify-content-center align-items-center">
            <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Immersive Audio That Speaks Volumes.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">WE MAKE IT SO YOU'RE ABLE TO LISTEN TO SOUND CRYSTAL CLEAR</h5>
                        <p className="section-description">Delivery shapes the message. At PROSLV, our comprehensive range of audio products and services guarantees crystal-clear communication and unforgettable entertainment experiences.
                           <br/> <br/>
                           {/* Morbi cursus quis dui sed lacinia. 
                           Cras quis ex lorem. Sed mauris ante, feugiat nec tortor ut, fringilla iaculis urna. Fusce lacus tortor, fermentum consectetur lacus ac, accumsan luctus ligula */}
                        </p>
                </div>
            </div>
          </div>
        </div>

        <div className="section black-bg client-section">

    <LogoSlider logos={logos}/>

    <div className="section-separator"></div>

    <div class="projects-section container mt-5">
    <h2 class="highlight-title mb-5">Our Projects</h2>
    <div class="projects-grid">
      <div class="project-card">
        <img src="/images/audio/prulife_audio.jpg" alt="Project 1" />
        <h3>PruLife HQ Hive Audio System</h3>
        <p></p>
      </div>
      {/* <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1025" alt="Project 2" />
        <h3>Project Two</h3>
        <p></p>
      </div>
      <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1033" alt="Project 3" />
        <h3>Project Three</h3>
        <p></p>
      </div>
      <div class="project-card">
        <img src="https://unsplash.it/400/250?image=1033" alt="Project 3" />
        <h3>Project Three</h3>
        <p></p>
      </div> */}
      
    </div>
  </div>
  </div>

      </Layout>
  );
}
